import { Translations } from "ui/Scripts/source/models/translations";
import { Base } from "ui/Scripts/source/framework/base";
import { FileAttachment, IFileAttachment } from "ui/Scripts/source/models/common/fileAttachment";

export interface IMessageShortListItem {
    id: string;
    companyId: string;
    date: number;
    title: string;
    content: string;
    userCode: string;
    userName: string;
    userPicture: string;
    typeImage: string;
    companyName: string;
    modifyDate: number;
    requiresReceiptIsRead: boolean;
    requiresReceipt: boolean;
    isRead: boolean;
    attachments: IFileAttachment[];

    getStateNumber(): number;
    getStateStr(): string;
    getStateNumberListSection(): number;
    getStateStrListSection(): string;
}

export class MessageShortListItem implements IMessageShortListItem {
    id: string;
    companyId: string;
    date: number;
    title: string;
    content: string;
    userCode: string;
    userName: string;
    userPicture: string;
    typeImage: string;
    companyName: string;
    modifyDate: number;
    requiresReceiptIsRead: boolean;
    requiresReceipt: boolean;
    isRead: boolean;
    attachments: FileAttachment[];

    constructor();
    constructor(obj: IMessageShortListItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.companyId = obj && obj.companyId || "";
        this.date = obj && obj.date || null;
        this.title = obj && obj.title || "";
        this.content = obj && obj.content || "";
        this.userCode = obj && obj.userCode || "";
        this.userName = obj && obj.userName || "";
        this.userPicture = obj && obj.userPicture || "";
        this.typeImage = obj && obj.typeImage || "";
        this.companyName = obj && obj.companyName || "";
        this.modifyDate = obj && obj.modifyDate || 0;
        this.requiresReceiptIsRead = obj && obj.requiresReceiptIsRead || false;
        this.requiresReceipt = obj && obj.requiresReceipt || false;
        this.isRead = obj && obj.isRead || false;
        this.attachments = Base.getTypedArray(obj ? obj.attachments : null, FileAttachment);
    }

    getStateNumber(): number {
        return this.requiresReceiptIsRead
            ? (this.requiresReceipt
                ? 4
                : 3)
            : (this.requiresReceipt
                ? 1
                : 2);
    }

    getStateStr(): string {
        return this.requiresReceiptIsRead
            ? (this.requiresReceipt
                ? Translations.ReadReceiptGiven
                : Translations.ReadImp)
            : (this.requiresReceipt
                ? Translations.ReadReceiptNotGiven
                : Translations.Unread);
    }

    getStateNumberListSection(): number {
        return this.requiresReceiptIsRead
            ? 3
            : (this.requiresReceipt
                ? 1
                : 2);
    }

    getStateStrListSection(): string {
        return this.requiresReceiptIsRead
            ? Translations.ReadImpPlur
            : (this.requiresReceipt
                ? Translations.ReadReceiptRequired
                : Translations.Unread);
    }
}